import { useContext, useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { AppContext, getEnvFromOrigin } from '../contexts/AppContext';
import storage from '../lib/storage';

type Data = {
  message?: string;
};

export default function Logout(): JSX.Element {
  const { setApp } = useContext(AppContext);
  const location = useLocation<Data>();
  const returnURL = encodeURIComponent(window.location.origin);

  useEffect(() => {
    storage.clear();
    const tokens = new Map<string, string>();
    setApp({ env: getEnvFromOrigin(), tokens });
    window.location.href = `${process.env.REACT_APP_OAUTH_LOGOUT_URL}?returnTo=${returnURL}&client_id=${process.env.REACT_APP_OAUTH_CLIENT_ID}`;
  }, [location, returnURL, setApp]);
  return <></>;
}
